import { ActionsOf, init } from "../utils";
import * as types from "../../constants";
import * as actions from "../actions-declarations/services";

export type ServicesActions = typeof actions;

export type ServicesType = {
  mixpanel: {
    openedTheAccessibility: null | object
    interactionWithTheAcc: null | object
    actionPerVisitor: null | object
  }
}

const defaultState = {
  mixpanel: {
    openedTheAccessibility: null,
    interactionWithTheAcc: null,
    actionPerVisitor: null
  }
}

export default function reducer(
  state = init<ServicesType>(defaultState),
  actions: ActionsOf<ServicesActions>
): typeof state {
  switch (actions.type) {
    case types.FETCH_OPENED_THE_ACCESSIBILITY:
      return {
        ...state,
        mixpanel: {
          ...state.mixpanel,
          openedTheAccessibility: actions.payload
        }
      };
    case types.FETCH_INTERACTION_WITH_THE_ACC:
      return {
        ...state,
        mixpanel: {
          ...state.mixpanel,
          interactionWithTheAcc: actions.payload,
        }
      };
    case types.FETCH_ACTION_PER_VISITOR:
      return {
        ...state,
        mixpanel: {
          ...state.mixpanel,
          actionPerVisitor: actions.payload,
        }
      };
    case types.CLEAR_MIXPANEL_DATA:
      return {
        ...state,
        mixpanel: {
          openedTheAccessibility: null!,
          interactionWithTheAcc: null!,
          actionPerVisitor: null!
        }
      }
    default:
      return state;
  }
}
